import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "9",
  height: "5",
  viewBox: "0 0 9 5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]


const __default__ = {};

interface IProps {
  fill: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ArrowDown',
  props: {
    fill: { default: "#999999" }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M7.97303 0.22343L4.5 3.57797L1.02697 0.22343C0.753112 -0.0682702 0.479256 -0.0743473 0.205395 0.205198C-0.0684651 0.484745 -0.0684651 0.75821 0.205395 1.0256L4.08921 4.81769C4.1888 4.93923 4.32573 5 4.5 5C4.67427 5 4.8112 4.93923 4.91079 4.81769L8.79461 1.0256C9.06846 0.75821 9.06846 0.484745 8.79461 0.205198C8.52074 -0.0743473 8.24689 -0.0682702 7.97303 0.22343Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_2)
  ]))
}
}

})